import * as React from "react";
import type { SVGProps } from "react";
const SvgInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <circle
      cx={8.399}
      cy={8.002}
      r={6.003}
      stroke="#7E8796"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#7E8796"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6.887 6.238 3.692 3.693M10.58 6.238 6.886 9.931"
    />
  </svg>
);
export default SvgInactive;
